import React, { Component } from "react";
import { Form, Button } from "react-bootstrap";
import auth from "../lib/auth-service";

class CreateUserForm extends Component {
    state = {
        validated: false,
        username: "",
        password: "",
        role: "user",
        message: "",
        error: ""
    };

    handleSubmit = event => {
        const form = event.currentTarget;
        event.preventDefault();
        if (form.checkValidity() === false) {
            event.stopPropagation();
            this.setState({ validated: true });
            return;
        }
        const { username, password, role } = this.state;
        auth
            .createUser({ username, password, role })
            .then(() => {
                this.setState({
                    validated: false,
                    username: "",
                    password: "",
                    role: "user",
                    message: `Usuario "${username}" creado correctamente.`,
                    error: ""
                });
            })
            .catch(({ response }) => {
                const status = response && response.status;
                const error =
                    status === 422
                        ? "Ese nombre de usuario ya existe."
                        : "No se pudo crear el usuario.";
                this.setState({ error, message: "" });
            });
        this.setState({ validated: true });
    };

    handleChange = event => {
        const { name, value } = event.target;
        this.setState({ [name]: name === "username" ? value.toLowerCase() : value });
    };

    render() {
        const { username, password, role, validated, message, error } = this.state;

        return (
            <div className="myContainer-sesion">
                <Form
                    noValidate
                    validated={validated}
                    onSubmit={this.handleSubmit}
                    className="text-center"
                >
                    <h2 className="center-log">Crear usuario</h2>
                    {message && <p style={{ color: "green" }}>{message}</p>}
                    {error && <p style={{ color: "red" }}>{error}</p>}
                    <Form.Group controlId="createUserUsername" className="sign">
                        <Form.Label>User</Form.Label>
                        <Form.Control
                            className="sign"
                            required
                            type="text"
                            name="username"
                            minLength="4"
                            value={username}
                            onChange={this.handleChange}
                            style={{ width: "15%", textAlign: "center" }}
                        />
                        <div className="line"></div>
                        <Form.Control.Feedback type="invalid">
                            Usuario requerido mínimo 4 carácteres
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group controlId="createUserPassword" className="sign">
                        <Form.Label>Password:</Form.Label>
                        <Form.Control
                            required
                            type="password"
                            name="password"
                            minLength="4"
                            value={password}
                            onChange={this.handleChange}
                            style={{ width: "15%", textAlign: "center" }}
                        />
                        <div className="line"></div>
                        <Form.Control.Feedback type="invalid">
                            Password requerido mínimo 4 carácteres
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group controlId="createUserRole" className="sign">
                        <Form.Label>Rol:</Form.Label>
                        <Form.Control
                            as="select"
                            name="role"
                            value={role}
                            onChange={this.handleChange}
                            style={{ width: "15%", margin: "0 auto" }}
                        >
                            <option value="user">Usuario</option>
                            <option value="admin">Administrador</option>
                        </Form.Control>
                    </Form.Group>
                    <Button variant="primary" type="submit">
                        Crear usuario
                    </Button>
                </Form>
            </div>
        );
    }
}

export default CreateUserForm;
